import { useState, useEffect, ReactNode } from 'react'
import { Form, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Switch from "react-switch";
import { ModemData } from '../../../api/Drone';
import { FrSetOgnIdRequestData, FrSetOgnViewRequestData } from '../../../api/Fr';
import { APIRequestPost } from '../../../utils/APIRequests';

interface OGNSettingsProps {
    drone: ModemData,
}

function OGNSettings({ drone }: OGNSettingsProps): ReactNode {
    const { t } = useTranslation(['modem']);

    const [ognId, setOgnId] = useState<string>(drone.ognId ?? "");
    const [ognSaveInfo, setOgnSaveInfo] = useState<string>("");
    const [isFrVis, setIsFrVis] = useState<boolean>(drone.isFrVis);
    // const [enabledSaveButton, setEnabledSaveButton] = useState(false);

    useEffect(() => {
        setOgnId(drone.ognId ?? "");
        setOgnSaveInfo("");
        setIsFrVis(drone.isFrVis);
    }, [drone]);

    /*useEffect(() => {
        setOgnSaveInfo("");
        setEnabledSaveButton(true);
    }, [modemSettings, rtspStr, fpvModeSettings, fpvLatencySettings]);
    */
    function saveOgnId(): void {
        const data: FrSetOgnIdRequestData = {
            ognId: ognId,
            imei: drone.imei
        };

        APIRequestPost('/fr/setOgnId', {
            data: data,
            logSuccess: true
        }).then(() => {
            setOgnSaveInfo(t('successfully').toString());
        }).catch(() => {
            setOgnSaveInfo(t('ogn_error').toString());
        });
    }

    function switchFrVis(): void {
        const data: FrSetOgnViewRequestData = {
            isFrVis: !isFrVis,
            imei: drone.imei
        };

        APIRequestPost('/fr/setOgnView', {
            data: data,
            logSuccess: true
        });

        setIsFrVis(!isFrVis);
    }

    return (
        <>
            <div className='t-18 ts-16'>OGN id:</div>
            <div className='settings-grid ts-16'>
                <div className='grid-1-4'>
                    <Form.Control
                        type="text"
                        placeholder={ognId}
                        onChange={(event) => { setOgnId(event.target.value) }}
                    />
                </div>
            </div>
            <div className='settings-grid ts-16'>
                <Button onClick={saveOgnId}>{t('save')}</Button>
                <div className='grid-ogn'>
                    <div className='ogn-switch'>
                        <Switch
                            onChange={() => { switchFrVis() }}
                            checked={isFrVis}
                            uncheckedIcon={false}
                            checkedIcon={false}
                            onColor='#EBFF00'
                            onHandleColor='#000000'
                            offHandleColor='#000000'
                            offColor='#494949'
                        />
                    </div>
                    <div>
                        {t('send_data_to_ogn')}
                    </div>
                </div>
            </div>
            <div className='settings-grid ts-16'>
                <div>{ognSaveInfo}</div>
            </div>
            <div className='grid-max'>
                <hr />
            </div>
            <div className='settings-grid ts-16'>
                <div className='grid-max t-14'>
                    Данные, которые отправляет модем AIR-LINK в сервис OGN, будут транслироваться через интернет на ближайшие наземные станции OGN, информация с которых будет отправлена летальным аппаратам поблизости.
                    Также они будут отправлены в сервисы отслеживания воздушных судов, таких как <a target="_blank" href='https://www.flightradar24.com/'>FlightRadar24</a>,
                    <a target="_blank" href='http://live.glidernet.org/'> OGN</a>, <a target="_blank" href='https://www.radarbox.com/'> RadarBox</a>.
                </div>
                <div className='grid-max t-14'>
                    Для отправки данных в OGN необходимо получить регистрационный номер на сайте <a target="_blank" href='https://ddb.glidernet.org/'>glidernet</a>.
                </div>
            </div>
        </>
    )
}

export default OGNSettings;